import { config } from "../../../config";
import { partsTypes } from "../../../selectOptions/partsTypes";
import { Part } from "../../../types/Part";
import { SelectOption } from "../../../types/SelectOption";
import { generateKeywordsArray } from "../../../util/helper";
import { LabelHelper } from "../../../util/labelHelper";

export const sanitizePart = (p: Part, models: SelectOption[], brands: SelectOption[]) => {
  if (p.yearMin === undefined || `${p.yearMin}` === '') {
    p.yearMin = config.yMin;
  }

  if (p.yearMax === undefined || `${p.yearMax}` === '') {
    p.yearMax = config.yMax;
  }

  setKeywordsOfParts(p, models, brands);
  return p;
};

// This method is used by other places where edit Parts
export const setKeywordsOfParts = (p: Part, models: SelectOption[], brands: SelectOption[]) => {
  const categotyLabels = LabelHelper.convertPartCategoryLabels(partsTypes, p.categories, []).join(' ');
  const fullStr = p.desc + ' ' + p.title + ' ' +
    LabelHelper.getBrandLabelEntity(p, brands) + ' ' +
    (p.yearMin ?? '').toString() + ' ' +
    (p.yearMax ?? '').toString() + ' ' +

    p.vehicleTypes.map(vehicleType => LabelHelper.getVehicleTypeLabel(vehicleType)).reduce((a, b) => a + ' ' + b, '') + ' ' +

    categotyLabels + ' ' +
    LabelHelper.getModelLabelEntity(p, models) + ' ' +
    p.chassis + ' ' +
    p.desc + ' ';

  // all the keywords are splitted together here
  p.keywords = generateKeywordsArray(fullStr);

  return p;
}
